
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../components/contexts/AuthContext";

const roleToPanelMap = {
  admin: "admin-panel",
  "customer care": "customer-panel",
  emailer: "emailer-panel",
  partner: "partner-panel",
};

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { panel } = useParams();

  if (loading) return <div>Loading...</div>;

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const allowedPanel = roleToPanelMap[user.role];

  if (panel && panel !== allowedPanel) {
    return <Navigate to={`/settings/${allowedPanel}`} replace />;
  }

  return children;
};

export default ProtectedRoute;

